import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from 'src/app/_services/project.service';
import * as bootstrap from 'bootstrap';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { HomeService } from 'src/app/_services/home.service';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
@Component({
  selector: 'app-rc',
  templateUrl: './rc.component.html',
  styleUrls: ['./rc.component.scss']
})
export class RcComponent implements OnInit {
  rcResponse: any;
  rcCategoryList: any[];
  createRCForm: UntypedFormGroup;
  @ViewChild("cancelCreateRC") cancelCreateRC: ElementRef;
  // userManagement: any;
  masterUsers: any;
  userName: any=[];
  selectedEmail: any;
  rcId: any;
  searchText:string='';
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Reusable Component',
    data: undefined,
  }
  constructor(private readonly project: ProjectService,
    private readonly toastrService: ToastrService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly userManagement: UserMgmtService,
    private readonly homeService: HomeService,
    private readonly confirmationDialogService: ConfirmationDialogService,

  ) { }
steps = [{
  "runState": "AC",
  "commandName": "OPENBROWSER",
  "pageName": "",
  "elementKey": "",
  "parameters": {
      "settingValue": "",
      "isMasked": false,
      "owner": "",
      "settingType": "STANDARD",
      "fieldType": "",
      "values": []
  },
  "testData": "",
  "stepComment": "",
  "maskedData": "",
  "runtimeData": false,
  "type": "AUTOMATIC",
  "debug": "NONE",
  "testStepResult": {
      "startTime": 0,
      "endTime": 0,
      "duration": 0,
      "auditInfoS": [],
      "resultState": {
          "passCount": -1,
          "failCount": -1,
          "incolusiveCount": -1,
          "notRunCount": -1,
          "modifiedCount": -1,
          "skippedCount": -1,
          "blockedCount": -1,
          "totalCount": 1
      },
      "aggrResultState": {
          "passCount": -1,
          "failCount": -1,
          "incolusiveCount": -1,
          "notRunCount": -1,
          "modifiedCount": -1,
          "skippedCount": -1,
          "blockedCount": -1,
          "totalCount": 1
      },
      "screenshotWeb": false
  },
  "active": "ENABLE",
  "evaluatedMetaValue": "",
  "hitlDialog": false
}]
  ngOnInit(): void {
    this.initAllForms();
     this.getRC();
     this.loadUsers()
     this.homeService.setHeaderOptions(this.headerOptions);
  }
getRC()
{
  this.project.getRC().subscribe((res: any) => {
    if (res) {
      this.rcResponse = res;
      let keys = Object.keys(this.rcResponse);
      let list = [];
      keys.forEach((key) => {
        let obj = { type: 'category', name: key, children: [] }
        let rcKeys = Object.keys(this.rcResponse[key]);
        rcKeys.forEach((rcKey) => {
          let rcObj = { type: 'rc', name: rcKey, children: this.rcResponse[key][rcKey] };
          obj.children.push(rcObj);
        })
        list.push(obj);
      })

      this.rcCategoryList = list;
      this.rcCategoryList.forEach(element => {
        element.children.forEach(childElement => {
          childElement.name = childElement.children.componentName
        });
      });
     console.log(this.rcCategoryList);

    }
  });
}
clearCategory()
{
  this.createRCForm.get('category')?.setValue('');
}
createRc()
{
  // console.log(this.createRCForm.value);
  let obj = {
    "componentName": this.createRCForm.value.componentName,
    "accessType": this.createRCForm.value.componentType,
    "category": this.createRCForm.value.category,
    "testSteps": this.steps
  }
  console.log("obj : ", obj);
  this.project.createRC(obj).subscribe((res)=>
  {
    this.createRCForm.reset();
    this.toastrService.clear();
    this.toastrService.success("Reusable component created, and navigate to test-step page to add some steps");
    this.cancelCreateRC.nativeElement.click();
    this.getRC()
  })

}

deleteRc(rc)
{
  this.confirmationDialogService
  .openConfirmDialog("Are you sure to delete " + rc.name + " ?")
  .afterClosed()
  .subscribe((res) => {
    if (res) {
      this.project.deleteRc(rc.children.id).subscribe((res)=>
        {
          console.log("res : ", res);
          this.toastrService.clear();
          this.toastrService.success('Reusable Component deleted successfully');
          this.getRC();
        })
    }
  });
}

initAllForms()
{
  this.createRCForm = this.formBuilder.group({
    componentName: ["", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
    componentType: ["public", [Validators.required]],
    category: ["", [Validators.required]]
  });
}


openCreateRCModal()
{
  // if(this.selectedSteps.length == 0)
  // {
  //   this.toastrService.clear();
  //   this.toastrService.warning("Select atleast one step to create Reusable component");
  //   return;
  // }
  // this.initAllForms();
  const modalElement = document.getElementById('create-rc');
  if (modalElement) {
    const modalInstance = new bootstrap.Modal(modalElement);
    modalInstance.show();
  }
}
loadUsers() {
  this.userManagement.loadUserData().subscribe((response) => {
    if(response['masteruser'].length){
      
      this.masterUsers = response['masteruser'];
      
      this.masterUsers.forEach((element ,i)=> {
        element.customIndex = i;
        this.userName.push(element.customer.email)
      });
      console.log('userName',this.userName);
      
    }  
 else{
  this.masterUsers.push(response['masteruser'])
  }
}
)}

selectuser(event){
this.selectedEmail = event;
}
captureRcId(rcId){
  this.rcId = rcId;
}

shareComponent(){
this.project.sendRC(this.selectedEmail,this.rcId).subscribe(
  (res:any)=>{
    this.toastrService.clear();
    this.toastrService.success('Component is shared successfully with ' + this.selectedEmail)
  }
)
}

filterRc(){
  console.log(this.rcCategoryList);
  var tempArray:any=[]
  this.rcCategoryList.forEach(element => {
    element.children.forEach(elementRc => {
      if(elementRc.children.componentName.includes(this.searchText)){

        tempArray.push(element)
        this.rcCategoryList=tempArray;
      }
      
    });
  });
}
}
